// extracted by mini-css-extract-plugin
module.exports = {"content":"MovieModal_content__1vdq5","close":"MovieModal_close__2hxJo","close__icon":"MovieModal_close__icon__24sME","iframe":"MovieModal_iframe__PBWcJ"};